import React from "react";
import { ErrorBoundary } from "components/ui/ErrorBoundary";
import { useFeatures } from "components/hooks/useFeatures";
import { useSlice } from "components/hooks/useSlice";
import { DelegateWelcomeCardUI } from "./DelegateWelcomeCard/DelegateWelcomeCardUI";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+Delegate+Welcome+Page
export function DelegateWelcomeCard() {
  const { csDelegatedAccess } = useFeatures();
  const { actingAsUid, delegateActingAsUid, advisorActingAsUid } =
    useSlice("myStatus");

  if (
    csDelegatedAccess &&
    !actingAsUid &&
    !delegateActingAsUid &&
    !advisorActingAsUid
  ) {
    return (
      <ErrorBoundary title="Linking Your Account">
        <DelegateWelcomeCardUI />
      </ErrorBoundary>
    );
  }

  return null;
}
